
/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
    "i18n/i18n",
    "component!list",
    "component!mustache",
    "utils/dom",
    "underscore",
    "backbone",
    "jquery"
  ],
  function(
    i18n,
    ListTemplate,
    MustacheTemplate,
    dom,
    _,
    Backbone,
    $
  ) {
  var ListView = ListTemplate.View;

  var AdderEntry = Backbone.Model.extend({
  
    create: function (application, parent, insertBefore) {
      var templateType = this.get("templateType"),
          el = application.create(templateType, this.get("options"));

      if (insertBefore) {
        try {
          parent.el && parent.el.insertBefore(el, insertBefore);
        } catch (e) {
          // append to default parent element
          this.appendChild(application.editor.defaultParent, el);
        }
      } else {
        this.appendChild(parent, el);
      }

      window.setTimeout(function () {
        application.reload(function () {
            application.displayEditor(application.templateTree.getEditableByEl(el));
        });
      }, 0);
    },

    appendChild: function (parent, el) {
     if (!el) {
       console && console.warn("Failed to append element");
       return;
     }
     parent.el && parent.el.appendChild(el) || parent.append(el);
    },

    // toJSON tries to translate every value, except the one for id
    toJSON: function () {
      var json = Backbone.Model.prototype.toJSON.apply(this, arguments);

      _.forEach(json, function (value, key) {
          json[key] = key === "id" ? value : i18n(value);
      });

      return json;
    }
  });

  var AdderGroup = Backbone.Model.extend({
    // toJSON tries to translate every value, except the one for id
    toJSON: function () {
      var json = Backbone.Model.prototype.toJSON.apply(this, arguments);

      _.forEach(json, function (value, key) {
          json[key] = key === "id" ? value : i18n(value);
      });

      return json;
    }
  });

  var Adders = Backbone.Collection.extend({
      model: AdderEntry
  });

  var AdderGroups = Backbone.Collection.extend({
      model: AdderGroup
  });

  AdderGroups.Adders = Adders;

  return AdderGroups;
});
